import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import * as _ from 'lodash';
import {
  LocationDropdown,
  Wrap,
  Loader,
  ErrorDisplay,
  Typography,
  Popup,
} from '../../components/index';
import Styled from './Rewards.style';
import { useTranslation } from 'react-i18next';
import { useResponsivity, scrollToTop } from '../../helpers/helpers';
import store from 'store2';
import TaskForm from './TaskForm';
interface RewardsProps {
  challenges: any;
  listLocation: any;
  getOffers: Function;
  setMeta: Function;
  postLeakRepairSignup: Function;
  leakFixSignup: any;
  user: any;
}
const Rewards: React.FC<RewardsProps> = (props) => {
  const {
    challenges,
    listLocation,
    setMeta,
    getOffers,
    postLeakRepairSignup,
    leakFixSignup,
    user,
  } = props;
  const [showPopup, setPopup] = React.useState(false);
  const isMobile = useResponsivity();
  const data = _.get(challenges, 'offers.data.challenges');

  const [t] = useTranslation('common');
  const title = 'Actions';

  const dataLocation = _.get(listLocation, 'data.data');
  const getLocationId = _.get(listLocation, 'data.data[0].id');
  const dataLength = _.get(dataLocation, 'length');
  const { loading, error } = _.get(challenges, 'status');
  const getValue = store.get('property');
  const properties = _.get(user, 'userData.data.properties');
  const findLocation = _.find(properties, function (o) {
    return o.id == parseInt(getValue);
  });

  const [value, setValue] = React.useState(`${getValue}`);
  const renderMapOptions =
    dataLocation &&
    dataLocation.map((el) => ({
      value: el.id,
      label: el.property_name,
    }));
  React.useEffect(() => {
    if (getValue === 'all') {
      store('property', getLocationId);
    }
    scrollToTop();
  }, [getValue, getLocationId]);
  React.useEffect(() => {
    if (!getValue) {
      store('property', getLocationId);
    } else if (dataLength === 1) {
      getOffers(getLocationId);
    } else if (getValue) {
      getOffers(getValue);
    }
  }, [getValue, getLocationId]);

  if (loading) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  if (error) {
    return (
      <Wrap>
        <ErrorDisplay />
      </Wrap>
    );
  }

  const renderOffers = () => {
    return (
      data &&
      data.map((el, index) => {
        return (
          <Col
            md={6}
            xs={12}
            sm={12}
            key={index}
            style={{ marginBottom: '16px' }}
          >
            <Styled.OfferWrap>
              <Popup
                isDesktop={!isMobile}
                open={showPopup}
                handleClick={() => setPopup(!showPopup)}
              >
                <TaskForm
                  postLeakRepairSignup={postLeakRepairSignup}
                  isDesktop={!isMobile}
                  description={t(el.description)}
                  buttonText={el.buttonText}
                  formElements={el.formElements}
                  icon={el.icon}
                  id={el.id}
                  tag={el.tag}
                  leakFixSignup={leakFixSignup}
                />
              </Popup>
              <Row>
                <Col md={6} xs={12} sm={12}>
                  <Typography size="3" text={el.title} />
                </Col>
                {findLocation && findLocation.wholesaler_slug && (
                  <Col
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <img
                      src={`https://cdn.getwaterfit.co.uk/static/files/logos/business/${findLocation.wholesaler_slug}-color.png`}
                      alt={findLocation.wholesaler}
                      style={{
                        height: '30px',
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Typography size="p" text={el.description} />
              <Styled.CustomButton
                onClick={() => {
                  if (el.type.includes('externalLink')) {
                    window.open(el.buttonPath, '_blank');
                  } else if (el.type.includes('fix-leak')) {
                    setPopup(true);
                  }
                }}
              >
                {el.buttonText}
              </Styled.CustomButton>
            </Styled.OfferWrap>
          </Col>
        );
      })
    );
  };
  return (
    <Wrap>
      <Row>
        <Col md={8} sm={12} xs={12}>
          <Typography
            size="1"
            weight={700}
            text={title}
            style={{
              marginBottom: '16px',
              fontSize: '40px',
              color: '#0b2641',
            }}
          />
        </Col>
        {dataLength <= 1 ? null : (
          <Col md={4} xs={12} sm={12}>
            <Styled.DropdownWrap>
              <LocationDropdown
                value={value === getValue ? value : getValue}
                onChange={(e) => {
                  e.preventDefault();
                  setValue(e.target.value);
                  store('property', e.target.value);
                  setMeta(getValue);
                }}
                options={renderMapOptions}
              />
            </Styled.DropdownWrap>
          </Col>
        )}
      </Row>
      <Row>{renderOffers()}</Row>
    </Wrap>
  );
};
export default Rewards;
